// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.gridview[data-v-f6d51cd2] .description-col {
  width: 70%;
}
.gridview[data-v-f6d51cd2] .action-col {
  width: 30%;
}
.tbody-scroll-table[data-v-f6d51cd2] table {
  width: 100%;
}
.tbody-scroll-table[data-v-f6d51cd2] tbody {
  display: block;
  max-height: 460px;
  min-height: 460px;
  overflow-y: scroll;
}
.tbody-scroll-table[data-v-f6d51cd2] tbody tr,
.tbody-scroll-table[data-v-f6d51cd2] thead,
.tbody-scroll-table[data-v-f6d51cd2] tfoot {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.tbody-scroll-table[data-v-f6d51cd2] tbody::-webkit-scrollbar {
  width: 6px;
}
.tbody-scroll-table[data-v-f6d51cd2] tbody::-webkit-scrollbar-thumb {
  background-color: #c7c7c7;
  border-radius: 3px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
